import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaStar, FaRegStar } from "react-icons/fa";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";



export default function SubCategory6({ data }) {
    const navigate = useNavigate();
    const baseImageUrl =
        "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";
    const categories = data.get_home_component_details.content.map((item) => ({
        id: item.subcategory_auto_id,
        name: item.sub_category_name,
    }));
    const webBackgroundColor = data.get_home_component_details.web_background_color || "#ffffff";
    const [activeCategory, setActiveCategory] = useState(categories[0]?.id || "");
    const [activeCategoryName, setActiveCategoryName] = useState(categories[0]?.name || "");
    const [productsData, setProductsData] = useState({}); // categoryID -> product array
    const [loading, setLoading] = useState(false);
    const [webFont, setWebFont] = useState("");
    const [themeColor, setThemeColor] = useState("");



    useEffect(() => {
        if (!activeCategory || productsData[activeCategory]) return;

        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/get_Admin_Subcategory_Product`,
                    {
                        customer_auto_id: sessionStorage.getItem("accessToken") || sessionStorage.getItem("admin_auto_id"),
                        admin_auto_id: sessionStorage.getItem("admin_auto_id"),
                        app_type_id: sessionStorage.getItem("app_type_id"),
                        sub_cat_id: activeCategory,
                        limit: "10",
                        page_number: "1"
                    }
                );

                const fetchedProducts = response.data?.get_admin_subcategory_product_lists || [];
                setProductsData((prev) => ({
                    ...prev,
                    [activeCategory]: fetchedProducts,
                }));
            } catch (error) {
                console.error("Failed to fetch products:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [activeCategory, productsData]);

    useEffect(() => {
        const storedStyle = sessionStorage.getItem("UIStyle");
        if (storedStyle) {
            const parsedStyle = JSON.parse(storedStyle);
            setWebFont(parsedStyle.web_font);
            setThemeColor(parsedStyle.web_theme_colour)
        }
    }, []);

    return (
        <div className={`p-4 ${webFont}`} style={{ backgroundColor: webBackgroundColor }}>
            {/* Categories */}
            <div className="flex gap-1 mb-4 overflow-x-auto whitespace-nowrap no-scrollbar">
                {categories.map((cat) => (
                    <button
                        key={cat.id}
                        onClick={() => {
                            setActiveCategory(cat.id);
                            setActiveCategoryName(cat.name);
                        }}
                        className={`text-sm px-3 py-1.5 rounded-full border whitespace-nowrap transition-all duration-200 ${activeCategory === cat.id
                            ? " text-white"
                            : "bg-transparent text-black border-gray-300"
                            }`}

                        style={{ backgroundColor: activeCategory === cat.id ? themeColor : "" }}
                    >
                        {cat.name}
                    </button>
                ))}
                <button className="text-sm px-3 py-1.5 rounded-full bg-black text-white whitespace-nowrap ml-auto"
                    onClick={() =>
                        navigate("/productlist", {
                            state: {
                                subcategoryName: activeCategoryName,
                                sub_cat_id: activeCategory,
                            },
                        })
                    }>
                    View All
                </button>
            </div>

            {/* Products Carousel */}
            {loading ? (
                <div className="py-10 text-center">Loading products...</div>
            ) : (
                <Swiper
                    spaceBetween={20}
                    breakpoints={{
                        320: {
                            slidesPerView: 1.2,
                        },
                        480: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                        1280: {
                            slidesPerView: 5,
                        },
                    }}
                >

                    {productsData[activeCategory]?.map((product, i) => {
                        const finalPrice = parseInt(product.final_product_price);
                        const originalPrice = parseInt(product.product_price);
                        const offerPercentage = parseInt(product.offer_percentage);

                        const isDiscounted = finalPrice > 0 && finalPrice !== originalPrice;

                        return (
                            <SwiperSlide key={i}>
                                <Link to={`/product-detail/${product.product_auto_id}`}

                                    className="no-underline text-decoration-none text-inherit">
                                    <div className="bg-white rounded-xl p-4 shadow border h-[380px] flex flex-col justify-between">
                                        {/* Tags */}
                                        <div className="flex items-center justify-start gap-2">
                                            {product.new_arrival === "Yes" && (
                                                <span className="px-2 py-1 text-xs text-white bg-black rounded-full">
                                                    New Arrival
                                                </span>
                                            )}
                                            {product.bought_count && (
                                                <span className="px-2 py-1 text-xs text-black bg-white border rounded-full">
                                                    {product.bought_count}+ Bought
                                                </span>
                                            )}
                                        </div>

                                        {/* Image */}
                                        <img
                                            src={
                                                baseImageUrl +
                                                (product.product_images?.[0]?.product_image || "")
                                            }
                                            alt={product.product_name}
                                            className="object-contain h-32 mx-auto my-4"
                                        />

                                        {/* Product Name */}
                                        <div className="text-sm font-medium leading-snug min-h-[48px]">
                                            {product.product_name.length > 60
                                                ? product.product_name.slice(0, 60) + "..."
                                                : product.product_name}
                                        </div>

                                        {/* Rating */}
                                        <div className="flex mt-2 text-sm text-yellow-500">
                                            {Array.from({ length: 5 }, (_, idx) =>
                                                idx < (product.avg_rating || 4) ? (
                                                    <FaStar key={idx} className="mr-1" />
                                                ) : (
                                                    <FaRegStar key={idx} className="mr-1" />
                                                )
                                            )}
                                        </div>

                                        {/* Pricing */}
                                        <div className="flex items-baseline gap-2 mt-2 text-sm">
                                            <span className="text-lg font-bold text-black">
                                                ₹
                                                {isDiscounted
                                                    ? finalPrice
                                                    : originalPrice}
                                            </span>

                                            {isDiscounted && (
                                                <span className="text-gray-500 line-through">
                                                    MRP ₹{originalPrice}
                                                </span>
                                            )}

                                            {offerPercentage > 0 && (
                                                <span className="px-2 py-1 text-xs text-white rounded-full " style={{ backgroundColor: themeColor }}>
                                                    {offerPercentage}% off
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </Link>

                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
        </div>
    );
}
